module.exports = __webpack_public_path__ + "static/media/3.75268a06.svg";